"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHttpClientConfig = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _lib = _interopRequireDefault(require("@xto10x/storage/lib"));
var _constants = require("./constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getDefaultHttpClientConfig = function getDefaultHttpClientConfig(productId) {
  var _ref;
  return {
    okr: {
      errorCodes: {
        '100': 'Invalid Request. Kindly reach out to us via support',
        '200': 'Invalid Request. Kindly reach out to us via support',
        '201': 'Title cannot be an empty field',
        '202': 'Status & Progress cannot be empty',
        '203': 'Start date cannot be greater than end date',
        '204': 'Choose either a weekly or a monthly format ',
        '205': 'Objective can’t be aligned',
        '206': 'Invalid due date',
        '207': 'Enter valid criteria for filtering',
        '208': 'Enter a valid status field',
        '209': 'This objective was updated recently. Please refresh',
        '210': 'Key result cannot be made company objective',
        '211': 'This cycle coincides partially/fully with an existing cycle',
        '212': 'Enter valid criteria for filtering',
        '213': 'Enter valid criteria for filtering',
        '216': 'Objective or Krs under this objective is already duplicated',
        '219': "You don't have access to this objective",
        '233': 'Invalid jira connection parameters',
        '234': "The jira issue that was used for tracking progress doesn't exists anymore",
        '235': "Can't track progress of an objective with metric",
        '236': 'Progress is already being tracked through jira',
        '237': 'Progress is not being tracked through jira',
        '238': "Can't delete jira connection tracking objective progress",
        '239': "Can't add metric to an objective whose progress is already being tracked",
        '251': 'This account is not active. Please contact Admin',
        '252': 'We do not recognize this organization. Please contact Admin',
        '253': 'Public KR can only be created under public Objective',
        '254': 'Protected KR can only be created under Public or Protected KR',
        '260': 'Owner needs to accept the objective before manager approval',
        '261': 'Manager approval flow is disabled',
        '262': 'Only manager can approve the objective',
        '263': 'Objective should be accepted and manager approved for check-in',
        '300': 'Invalid Request. Kindly reach out to us via support',
        '301': 'No default objective cycle present',
        '400': 'Something went wrong. Please refresh',
        '401': 'Invalid user',
        '402': 'Objective doesn’t exist',
        '403': 'Invalid objective cycle',
        '404': 'Invalid notification group Id',
        '405': 'Invalid notification id',
        '406': 'Team doesn’t exist',
        '600': 'Something went wrong. Please refresh',
        '601': 'Objective cycle already present with the same name',
        '602': 'This team already exists',
        '603': 'Jira connection already present with the same name',
        '700': 'Looks like someone else is also working on it. Kindly check back in a few minutes',
        '800': 'Sorry, you don’t have required access. Please refresh and try again.',
        '801': 'Please use Google sign-in. Email authentication is blocked by your organisation.',
        '802': 'You do not have access to this tool as your organization has unsubscribed. Kindly contact our team to re-start your license.',
        '803': 'Contact admin for enabling Slack integration.',
        '900': 'Session expired. Revalidating...',
        '904': "Sorry, you don't have the permission to change the order within this parent objective",
        "default": 'An error has occurred. Please try again after some time',
        timeout: 'Please check your network connection and try again.'
      },
      apiHandlerConfig: {
        refresh_error_codes: [900, 700, 100, 232, 240, 218],
        sign_out_error_codes: [800, 801, 802],
        timeout: 60000
      }
    },
    people: {
      errorCodes: {
        '100': 'Invalid Request. Kindly reach out to us via support',
        '200': 'Invalid Request. Kindly reach out to us via support',
        '209': 'Looks like question is already filled from some other device. Please refresh',
        '251': 'This account is not active. Please contact Admin',
        '252': 'We do not recognize this organization. Please contact Admin',
        '300': 'Invalid Request. Kindly reach out to us via support',
        '301': 'No default objective cycle present',
        '400': 'Something went wrong. Please refresh',
        '401': 'Invalid user',
        '409': 'Looks like question is already filled from some other device. Please refresh',
        '600': 'Something went wrong. Please refresh',
        '800': "Sorry, you don't have required access. Please refresh and try again.",
        '801': 'Email authentication is blocked for your organisation. Kindly use Google sign-in.',
        '802': 'You do not have access to this tool as your organization has unsubscribed. Kindly contact our team to re-start your license.',
        '900': 'Session expired. Revalidating...',
        "default": 'An error has occurred. Please try again after some time'
      },
      apiHandlerConfig: {
        refresh_error_codes: [700, 100],
        sign_out_error_codes: [800, 801, 802, 900],
        timeout: 60000
      }
    }
  }[(_ref = productId || _lib["default"].getDataFromLocal(_constants.StorageKey.PRODUCT_ID)) === null || _ref === void 0 ? void 0 : _ref.toLowerCase()] || {
    apiHandlerConfig: {
      refresh_error_codes: [700, 100],
      sign_out_error_codes: [800, 801, 802],
      timeout: 60000
    }
  };
};
var getHttpClientConfig = exports.getHttpClientConfig = function getHttpClientConfig() {
  var productId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var defaultHttpClientConfig = getDefaultHttpClientConfig(productId);
  var httpClientConfig = _lib["default"].getDataFromLocal(_constants.StorageKey.HTTP_CLIENT_CONFIG);
  return {
    errorCodes: _objectSpread(_objectSpread({}, (defaultHttpClientConfig === null || defaultHttpClientConfig === void 0 ? void 0 : defaultHttpClientConfig.errorCodes) || null), (httpClientConfig === null || httpClientConfig === void 0 ? void 0 : httpClientConfig.errorCodes) || null),
    apiHandlerConfig: _objectSpread(_objectSpread({}, (defaultHttpClientConfig === null || defaultHttpClientConfig === void 0 ? void 0 : defaultHttpClientConfig.apiHandlerConfig) || null), (httpClientConfig === null || httpClientConfig === void 0 ? void 0 : httpClientConfig.apiHandlerConfig) || null)
  };
};